module.exports = __webpack_public_path__ + "static/img/zbry.efe320b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/zbry.png
// module id = XNhv
// module chunks = 0